import { cn } from "@/lib/utils";
import { STATUS_LABELS } from "@/lib/format";

const STYLES = {
  paid: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400",
  approved: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400",
  pending: "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400",
  unpaid: "bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-400",
  draft: "bg-slate-100 text-slate-600 dark:bg-slate-700/40 dark:text-slate-300",
  cancel: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400",
  rejected: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400",
};

export const StatusBadge = ({ status }) => (
  <span
    data-testid={`status-${status}`}
    className={cn(
      "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold",
      STYLES[status] || STYLES.draft
    )}
  >
    {STATUS_LABELS[status] || status}
  </span>
);

export default StatusBadge;
